import resellersModule from "../resellersModule.js";

const resellersPaneComponent = {
    templateUrl: "resellers-pane",
    bindings: {
        "resaleData": "<",
        "assetData": "<",
        "economyMetadata": "<"
    },
    controller: "resellersPaneController"
};

resellersModule.component("resellersPane", resellersPaneComponent);
export default resellersPaneComponent;